import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { useQuery } from '@tanstack/react-query';

/**
 * Cotação em tempo real da proposta RD Equipamentos (`GET /:proposalId/quote`).
 * `enabled` é exposto como parâmetro porque o cálculo só deve ser buscado
 * quando o step de Cotação (ou Coberturas, para pré-visualização) está ativo.
 *
 * `refetchOnMount: 'always'` é defesa em profundidade contra prêmio
 * desatualizado: `use-set-rd-params.hook.ts`/`use-set-rd-coverages.hook.ts`
 * já refetcham `['rd-quote', proposalId]` explicitamente no sucesso, mas
 * forçar o refetch também ao montar o Step Cotação garante que qualquer
 * outra rota de escrita (presente ou futura) que não invalide essa key não
 * deixe a tela mostrando um valor em cache obsoleto.
 */
export function useRdQuote(proposalId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['rd-quote', proposalId],
    queryFn: async () => {
      if (!proposalId) {
        throw new Error('ProposalId é obrigatório');
      }

      const response = await rdEquipamentosService.getQuote(proposalId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao buscar cotação');
      }

      return response.data;
    },
    enabled: enabled && !!proposalId,
    refetchOnMount: 'always',
  });
}
